function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "apron",
    style: {
      height: "100%",
      width: "100%",
      background: "rgb(255, 255, 255)"
    },
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.833333s infinite normal forwards running breath-ca914042-e58c-40c4-bf29-66f35a2d8c4a"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#333",
    fill: "#a0c8d7",
    d: "M65.1 25.8V7.5h-4.9v13.4c0 3.6-2.7 6.5-6.1 6.5h-8.3c-3.4 0-6.1-2.9-6.1-6.5V7.5h-4.9v18.3c0 5.7-3.8 10.5-8.9 11.7l-4.1 48.1c0 9.1 56.2 9.1 56.2 0l-4-48c-5.1-1.3-8.9-6-8.9-11.8z",
    style: {
      fill: "rgb(160, 200, 215)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running breath-ca914042-e58c-40c4-bf29-66f35a2d8c4a"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#333",
    fill: "#77a4bd",
    d: "M62.5 75.1c0 8.3-25 8.3-25 0V61.9c0-2 1.6-3.6 3.6-3.6H59c2 0 3.6 1.6 3.6 3.6l-.1 13.2z",
    style: {
      fill: "rgb(119, 164, 189)",
      stroke: "rgb(51, 51, 51)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApron);
export default __webpack_public_path__ + "static/media/apron.10319af021b76e9e6d1978eaba54cc60.svg";
export { ForwardRef as ReactComponent };